import { Inputs } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { useFlags } from 'Hooks/useFlags';
import CustomTransition from 'Components/CustomTransition';
import FlowColLayout from 'Components/Layouts/FlowColLayout';
import { FlagsKey, TaxProfile } from 'Types/common';
import * as Styled from './styles';
import { ViewProps } from './types';
import ChatBoxButton from './components/ChatBoxButton';
import InformationContainer from './components/InformationContainer';
import { resultBoxComponent, TaxReturnTypes } from './utils';
import ResultDetail from './components/ResultDetail';

const Result = ({ data, previousYears, userProfile }: ViewProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const { enabled: flowEnabled } = useFlags(FlagsKey.FLOW_ENABLED);
  const wizardOptions = [
    { id: '1', label: t('result:Result.step.one'), value: 1 },
    { id: '2', label: t('result:Result.step.two'), value: 2 },
    { id: '3', label: t('result:Result.step.three'), value: 3 },
  ];
  const showPreviousYearBanner =
    previousYears?.approve && previousYears?.returnType === TaxReturnTypes.TO_RETURN;

  const Component = resultBoxComponent[data?.taxReturnType];
  return (
    <FlowColLayout section="result" isFlow>
      <CustomTransition start>
        <Styled.Container
          direction="column"
          align="center"
          fullHeight
          type={data?.taxReturnType}
          gap="dimension_24"
        >
          <Styled.WizardBox>
            <Inputs.Wizard options={wizardOptions} value={1} />
          </Styled.WizardBox>
          {data && (
            <Component
              data={data}
              flowEnabled={flowEnabled}
              showPreviousYearBanner={showPreviousYearBanner}
            />
          )}
          {data?.warnings?.length > 0 && userProfile?.taxProfile === TaxProfile.COMPLEX && (
            <ResultDetail warning={data?.warnings} />
          )}
          <InformationContainer data={data} />
          <ChatBoxButton />
        </Styled.Container>
      </CustomTransition>
    </FlowColLayout>
  );
};

export default Result;
